class AddressForm {
  form = null
  countrySelect = null
  stateField = null
  regionField = null
  zipLabel = null
  zipField = null

  constructor(form) {
    this.form = form

    this.countrySelect = this.form.querySelector('.js-country-select')
    this.stateField = this.form.querySelector('.js-state-field')
    this.regionField = this.form.querySelector('.js-region-field')
    this.zipField = this.form.querySelector('.js-address-zip')
    this.zipLabel = this.form.querySelector('.js-zip-label')

    this.countrySelect.addEventListener('change', () => {
      this.updateFields()
    })

    // Load initial page state.
    this.updateFields()
  }

  updateFields() {
    if (this.countrySelect.value === 'US') {
      this.stateField.classList.remove('u-hidden')
      this.regionField.classList.add('u-hidden')
      this.zipLabel.innerHTML = 'Zip code'
      this.zipField.placeholder = '00000'
    } else {
      this.stateField.classList.add('u-hidden')
      this.regionField.classList.remove('u-hidden')
      this.zipLabel.innerHTML = 'Postal code'
      this.zipField.placeholder = 'DK1M 59F'
    }
  }
}

document.addEventListener('turbolinks:load', () => {
  const form = document.querySelector('.js-address-form')

  if (form) {
    new AddressForm(form)
  }
})
